var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _path3, _mask, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect9, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _mask2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSea04(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0234375,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#2E4491"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.876 65.9704L218.481 69.8913L188.904 172.52L175.299 168.599L204.876 65.9704ZM218.482 69.8897L232.087 73.8106L202.51 176.439L188.905 172.518L218.482 69.8897ZM216.116 180.361L229.72 184.281L229.719 184.283L243.324 188.204L272.901 85.5759L259.297 81.6551L259.297 81.653L245.692 77.732L245.692 77.7333L232.088 73.8127L202.511 176.441L216.116 180.362L216.116 180.361ZM286.507 89.4953L272.902 85.5744L243.325 188.203L256.93 192.124L256.93 192.126L270.535 196.047L300.112 93.4183L286.507 89.4974L286.507 89.4953Z",
    fill: "#442B26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 209.23,
    y: 67.0195,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 209.23 67.0195)",
    fill: "#FFE3DE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 222.834,
    y: 70.9414,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 222.834 70.9414)",
    fill: "#FF775E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 236.439,
    y: 74.8672,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 236.439 74.8672)",
    fill: "#FFE3DE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 250.045,
    y: 78.7852,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 250.045 78.7852)",
    fill: "#FF775E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 277.256,
    y: 86.625,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 277.256 86.625)",
    fill: "#FF775E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 263.648,
    y: 82.7031,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 263.648 82.7031)",
    fill: "#FFE3DE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 290.861,
    y: 90.5469,
    width: 14.1588,
    height: 106.805,
    transform: "rotate(16.0767 290.861 90.5469)",
    fill: "#FFE3DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.04 116.496C264.058 119.78 263.23 125.555 266.128 129.826L281.808 152.929L297.308 143.855L284.143 117.878C281.456 112.575 274.545 111.131 269.958 114.914L268.04 116.496ZM297.306 143.858C299.565 147.716 297.909 152.885 293.618 155.397C289.327 157.909 284.068 156.789 281.809 152.931L297.306 143.858Z",
    fill: "#442B26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.435 115.566C265.559 118.858 264.771 124.534 267.603 128.758L283.247 152.087L283.247 152.087C285.506 155.944 290.478 157.233 294.408 154.932C298.339 152.631 299.702 147.634 297.444 143.776L297.446 143.775L283.723 117.033C281.239 112.193 274.893 110.931 270.747 114.452L269.435 115.566Z",
    fill: "#FFE0DB"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-12-inside-1_569_27174",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.435 115.566C265.559 118.858 264.771 124.534 267.603 128.758L283.247 152.087L283.247 152.087C285.506 155.944 290.478 157.233 294.408 154.932C298.339 152.631 299.702 147.634 297.444 143.776L297.446 143.775L283.723 117.033C281.239 112.193 274.893 110.931 270.747 114.452L269.435 115.566Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M267.603 128.758L268.434 128.201L267.603 128.758ZM269.435 115.566L268.788 114.804L268.788 114.804L269.435 115.566ZM283.247 152.087L282.417 152.644L282.94 153.425L283.752 152.95L283.247 152.087ZM283.247 152.087L284.11 151.582L283.605 150.719L282.742 151.224L283.247 152.087ZM297.444 143.776L296.939 142.913L296.076 143.418L296.581 144.281L297.444 143.776ZM297.446 143.775L297.951 144.638L298.767 144.16L298.335 143.318L297.446 143.775ZM283.723 117.033L282.833 117.489L282.833 117.489L283.723 117.033ZM270.747 114.452L270.099 113.69L270.747 114.452ZM268.434 128.201C265.885 124.399 266.594 119.291 270.083 116.328L268.788 114.804C264.524 118.424 263.657 124.669 266.772 129.314L268.434 128.201ZM284.078 151.53L268.434 128.201L266.772 129.314L282.417 152.644L284.078 151.53ZM282.742 151.224L282.742 151.224L283.752 152.95L283.753 152.95L282.742 151.224ZM282.385 152.592C284.927 156.934 290.515 158.37 294.914 155.795L293.903 154.069C290.441 156.095 286.086 154.955 284.11 151.582L282.385 152.592ZM294.914 155.795C299.304 153.224 300.854 147.621 298.307 143.27L296.581 144.281C298.551 147.646 297.373 152.037 293.903 154.069L294.914 155.795ZM296.94 142.912L296.939 142.913L297.949 144.639L297.951 144.638L296.94 142.912ZM282.833 117.489L296.556 144.231L298.335 143.318L284.612 116.576L282.833 117.489ZM271.394 115.214C275.049 112.11 280.643 113.223 282.833 117.489L284.612 116.576C281.834 111.163 274.737 109.752 270.099 113.69L271.394 115.214ZM270.083 116.328L271.394 115.214L270.099 113.69L268.788 114.804L270.083 116.328Z",
    fill: "#C76553",
    mask: "url(#path-12-inside-1_569_27174)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M273.3 120.77L274.675 122.027L272.517 137.918V137.918C271.456 136.104 271.066 133.974 271.417 131.902L273.3 120.77Z",
    fill: "#8D655E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.575 120.023L274.998 121.838L289.911 127.734V127.734C288.849 125.921 287.183 124.539 285.204 123.83L274.575 120.023Z",
    fill: "#8D655E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M272.529 119.447L273.68 121.413L272.487 138.817L272.018 138.016C270.867 136.052 270.421 133.755 270.753 131.503L272.529 119.447Z",
    fill: "#FF775E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M272.529 119.447L273.68 121.413L272.487 138.817L272.018 138.016C270.867 136.052 270.421 133.755 270.753 131.503L272.529 119.447Z",
    fill: "url(#paint0_linear_569_27174)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M273.681 121.417L272.53 119.451L272.455 119.959C272.489 120.002 273.26 121.329 273.642 121.987L273.681 121.417Z",
    fill: "#753124"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M281.391 148.01C281.599 148.224 281.961 148.079 281.964 147.781V147.781C281.965 147.705 281.94 147.631 281.893 147.572L272.686 135.871L272.479 138.808L281.391 148.01Z",
    fill: "#B44C38"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M272.48 138.808L272.686 135.871L273.327 136.685L273.339 139.696L272.48 138.808Z",
    fill: "#753124"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.42 140.381C294.505 140.666 294.202 140.911 293.94 140.768V140.768C293.874 140.732 293.822 140.674 293.792 140.603L288.096 126.847L290.759 128.105L294.42 140.381Z",
    fill: "#B44C38"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M273.854 118.674L275.005 120.641L290.765 128.119L290.297 127.318C289.148 125.354 287.363 123.84 285.237 123.027L273.854 118.674Z",
    fill: "#FF775E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M273.854 118.674L275.005 120.641L290.765 128.119L290.297 127.318C289.148 125.354 287.363 123.84 285.237 123.027L273.854 118.674Z",
    fill: "url(#paint1_linear_569_27174)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M275.004 120.641L273.853 118.674L274.333 118.858C274.354 118.908 275.133 120.231 275.521 120.885L275.004 120.641Z",
    fill: "#753124"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M290.759 128.105L288.096 126.847L288.493 127.804L291.112 129.289L290.759 128.105Z",
    fill: "#753124"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 271.945,
    y: 118.445,
    width: 1.52913,
    height: 4.58739,
    rx: 0.764566,
    transform: "rotate(-30.3463 271.945 118.445)",
    fill: "#FF7258"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M285.607 152.156L283.6 148.727L284.888 147.972C285.674 147.512 286.374 147.745 286.762 148.402C287.143 149.059 286.998 149.784 286.207 150.247L285.544 150.635L286.223 151.796L285.607 152.156ZM285.247 150.128L285.825 149.79C286.288 149.516 286.344 149.133 286.132 148.771C285.917 148.404 285.56 148.272 285.096 148.544L284.518 148.882L285.247 150.128Z",
    fill: "#F2CBC5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M288.808 150.333C288.605 150.453 288.339 150.385 288.222 150.18C288.104 149.983 288.176 149.721 288.378 149.599C288.576 149.486 288.84 149.551 288.957 149.75C289.076 149.954 289.005 150.218 288.808 150.333Z",
    fill: "#F2CBC5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M289.762 149.724L287.754 146.294L289.043 145.54C289.829 145.08 290.528 145.313 290.916 145.97C291.298 146.627 291.153 147.352 290.362 147.815L289.698 148.203L290.378 149.364L289.762 149.724ZM289.402 147.696L289.98 147.358C290.442 147.084 290.498 146.701 290.286 146.339C290.071 145.971 289.714 145.84 289.25 146.112L288.672 146.45L289.402 147.696Z",
    fill: "#F2CBC5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M291.326 144.203L293.334 147.633L292.727 147.988L290.72 144.558L291.326 144.203Z",
    fill: "#F2CBC5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M295.084 146.678C294.309 147.132 293.531 146.894 293.06 146.089C292.594 145.293 292.761 144.47 293.495 144.04C294.125 143.671 294.901 143.748 295.43 144.65L295.541 144.84L293.745 145.891C294.011 146.324 294.422 146.433 294.811 146.202C295.078 146.049 295.189 145.831 295.177 145.632L295.769 145.285C295.921 145.794 295.681 146.329 295.084 146.678ZM293.506 145.478L294.721 144.766C294.514 144.417 294.127 144.3 293.779 144.504C293.417 144.716 293.336 145.138 293.506 145.478Z",
    fill: "#F2CBC5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.564 97.7086C281.746 93.6442 287.498 92.669 291.841 95.4577L315.337 110.543L306.661 126.269L280.357 113.772C274.987 111.22 273.366 104.348 277.031 99.6667L278.564 97.7086ZM306.662 126.269C310.576 128.428 315.701 126.641 318.103 122.287C320.505 117.934 319.251 112.704 315.336 110.545L306.662 126.269Z",
    fill: "#442B26"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.542 97.4988C281.733 93.54 287.388 92.607 291.682 95.3306L315.401 110.373L315.402 110.371C319.316 112.53 320.731 117.468 318.531 121.456C316.331 125.443 311.372 126.934 307.458 124.776L307.456 124.781L280.372 111.744C275.471 109.385 274.047 103.073 277.462 98.8381L278.542 97.4988Z",
    fill: "#FFE0DB"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-28-inside-2_569_27174",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.542 97.4988C281.733 93.54 287.388 92.607 291.682 95.3306L315.401 110.373L315.402 110.371C319.316 112.53 320.731 117.468 318.531 121.456C316.331 125.443 311.372 126.934 307.458 124.776L307.456 124.781L280.372 111.744C275.471 109.385 274.047 103.073 277.462 98.8381L278.542 97.4988Z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M291.682 95.3306L291.147 96.175L291.682 95.3306ZM278.542 97.4988L279.32 98.1265L279.32 98.1265L278.542 97.4988ZM315.401 110.373L316.276 110.856L315.763 111.787L314.865 111.217L315.401 110.373ZM315.402 110.371L314.526 109.888L315.009 109.012L315.885 109.495L315.402 110.371ZM307.458 124.776L306.582 124.293L307.065 123.418L307.941 123.901L307.458 124.776ZM307.456 124.781L308.331 125.264L307.874 126.092L307.022 125.682L307.456 124.781ZM280.372 111.744L280.806 110.843L280.806 110.843L280.372 111.744ZM277.462 98.8381L276.683 98.2104L276.683 98.2104L277.462 98.8381ZM291.147 96.175C287.282 93.7239 282.193 94.5636 279.32 98.1265L277.763 96.8712C281.274 92.5165 287.494 91.4902 292.218 94.4861L291.147 96.175ZM314.865 111.217L291.147 96.175L292.218 94.4861L315.936 109.528L314.865 111.217ZM314.525 109.89L314.526 109.888L316.277 110.854L316.276 110.856L314.525 109.89ZM315.885 109.495C320.291 111.926 321.869 117.475 319.407 121.939L317.655 120.973C319.593 117.46 318.341 113.135 314.919 111.246L315.885 109.495ZM319.407 121.939C316.95 126.393 311.389 128.085 306.975 125.652L307.941 123.901C311.355 125.782 315.713 124.493 317.655 120.973L319.407 121.939ZM306.58 124.298L306.582 124.293L308.334 125.259L308.331 125.264L306.58 124.298ZM280.806 110.843L307.889 123.88L307.022 125.682L279.939 112.645L280.806 110.843ZM278.24 99.4658C275.23 103.199 276.485 108.763 280.806 110.843L279.939 112.645C274.456 110.006 272.864 102.947 276.683 98.2104L278.24 99.4658ZM279.32 98.1265L278.24 99.4658L276.683 98.2104L277.763 96.8712L279.32 98.1265Z",
    fill: "#C76553",
    mask: "url(#path-28-inside-2_569_27174)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M283.842 101.228L285.134 102.571L300.965 100.008V100.008C299.124 98.9935 296.985 98.6584 294.923 99.0617L283.842 101.228Z",
    fill: "#8D655E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M283.129 102.526L284.954 102.902L291.228 117.66V117.66C289.388 116.645 287.964 115.014 287.205 113.054L283.129 102.526Z",
    fill: "#8D655E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M282.503 100.492L284.498 101.593L301.865 99.9564L301.053 99.5079C299.06 98.4078 296.752 98.0203 294.51 98.4093L282.503 100.492Z",
    fill: "#FF775E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M282.503 100.492L284.498 101.593L301.865 99.9564L301.053 99.5079C299.06 98.4078 296.752 98.0203 294.51 98.4093L282.503 100.492Z",
    fill: "url(#paint2_linear_569_27174)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M284.498 101.593L282.503 100.493L283.009 100.405C283.053 100.438 284.399 101.175 285.067 101.54L284.498 101.593Z",
    fill: "#753124"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M311.278 108.623C311.497 108.825 311.362 109.191 311.065 109.202V109.202C310.989 109.204 310.914 109.181 310.853 109.136L298.921 100.23L301.853 99.9486L311.278 108.623Z",
    fill: "#B44C38"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M301.852 99.9517L298.92 100.233L299.751 100.853L302.761 100.788L301.852 99.9517Z",
    fill: "#753124"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M303.987 121.843C304.274 121.92 304.512 121.611 304.362 121.353V121.353C304.324 121.287 304.265 121.237 304.194 121.209L290.297 115.866L291.622 118.495L303.987 121.843Z",
    fill: "#B44C38"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M281.761 101.836L283.756 102.936L291.634 118.501L290.821 118.053C288.828 116.954 287.27 115.208 286.403 113.104L281.761 101.836Z",
    fill: "#FF775E"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M281.761 101.836L283.756 102.936L291.634 118.501L290.821 118.053C288.828 116.954 287.27 115.208 286.403 113.104L281.761 101.836Z",
    fill: "url(#paint3_linear_569_27174)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M283.756 102.936L281.761 101.836L281.957 102.311C282.008 102.33 283.349 103.076 284.014 103.446L283.756 102.936Z",
    fill: "#753124"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M291.621 118.499L290.296 115.869L291.263 116.24L292.814 118.821L291.621 118.499Z",
    fill: "#753124"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1.52913,
    height: 4.58739,
    rx: 0.764566,
    transform: "matrix(-0.483053 0.875591 0.875591 0.483053 281.484 99.9336)",
    fill: "#FF7258"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_569_27174",
    x1: 272.529,
    y1: 119.447,
    x2: 274.685,
    y2: 137.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753124",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_569_27174",
    x1: 278.093,
    y1: 116.193,
    x2: 286.528,
    y2: 130.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B44C38",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_569_27174",
    x1: 282.502,
    y1: 100.493,
    x2: 300.197,
    y2: 102.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#753124",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_569_27174",
    x1: 279.388,
    y1: 106.137,
    x2: 294.006,
    y2: 114.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D94D33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B44C38",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea04);
export default __webpack_public_path__ + "static/media/sea_04.21afe15b6cf96d67a776886e2844e60d.svg";
export { ForwardRef as ReactComponent };